import { render, staticRenderFns } from "./ValidadorPoliticaComercial.vue?vue&type=template&id=30786fa0"
import script from "./ValidadorPoliticaComercial.vue?vue&type=script&lang=js"
export * from "./ValidadorPoliticaComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports